import { Icon as IconifyIcon } from '@iconify/react';

const Iconify = (props) => <IconifyIcon {...props} />;

export default Iconify;
